import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

export default function Achievements() {
  return (
    <div className="min-h-screen bg-gradient-to-b from-dark-navy via-[#0D1128] to-dark-navy font-cairo">
      <div className="fixed inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PHBhdHRlcm4gaWQ9ImdyaWQiIHdpZHRoPSI2MCIgaGVpZ2h0PSI2MCIgcGF0dGVyblVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+PHBhdGggZD0iTSAxMCAwIEwgMCAwIDAgMTAiIGZpbGw9Im5vbmUiIHN0cm9rZT0icmdiYSgwLDIxNywyNTUsMC4wNSkiIHN0cm9rZS13aWR0aD0iMSIvPjwvcGF0dGVybj48L2RlZnM+PHJlY3Qgd2lkdGg9IjEwMCUiIGhlaWdodD0iMTAwJSIgZmlsbD0idXJsKCNncmlkKSIvPjwvc3ZnPg==')] opacity-30 pointer-events-none"></div>
      
      <Navbar />

      <main className="relative">
        {/* Hero Section */}
        <section className="pt-32 pb-16 px-6">
          <div className="container mx-auto text-center">
            <h1 className="text-5xl md:text-6xl font-bold text-white mb-6">
              الإنجازات وسجل الأداء الموثق
            </h1>
            <p className="text-xl text-gray-300 max-w-3xl mx-auto">
              سجل حافل من النجاحات والشراكات الاستراتيجية منذ 2017
            </p>
          </div>
        </section>

        {/* Key Metrics */}
        <section className="py-16 px-6">
          <div className="container mx-auto">
            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4 max-w-6xl mx-auto">
              <div className="bg-gradient-to-br from-dark-card to-dark-navy border border-neon-cyan/30 rounded-2xl p-6 text-center hover:shadow-lg hover:shadow-neon-cyan/20 transition-all duration-300">
                <div className="w-12 h-12 flex items-center justify-center mx-auto mb-3">
                  <i className="ri-calendar-line text-3xl text-neon-cyan"></i>
                </div>
                <div className="text-3xl font-bold text-white mb-2">2017</div>
                <div className="text-sm text-gray-400">سنة التأسيس</div>
              </div>

              <div className="bg-gradient-to-br from-dark-card to-dark-navy border border-neon-green/30 rounded-2xl p-6 text-center hover:shadow-lg hover:shadow-neon-green/20 transition-all duration-300">
                <div className="w-12 h-12 flex items-center justify-center mx-auto mb-3">
                  <i className="ri-percent-line text-3xl text-neon-green"></i>
                </div>
                <div className="text-3xl font-bold text-white mb-2">~27%</div>
                <div className="text-sm text-gray-400">متوسط عائد سنوي</div>
              </div>

              <div className="bg-gradient-to-br from-dark-card to-dark-navy border border-neon-green/30 rounded-2xl p-6 text-center hover:shadow-lg hover:shadow-neon-green/20 transition-all duration-300">
                <div className="w-12 h-12 flex items-center justify-center mx-auto mb-3">
                  <i className="ri-file-list-3-line text-3xl text-neon-green"></i>
                </div>
                <div className="text-3xl font-bold text-white mb-2">71</div>
                <div className="text-sm text-gray-400">عدد الصفقات</div>
              </div>

              <div className="bg-gradient-to-br from-dark-card to-dark-navy border border-blue-400/30 rounded-2xl p-6 text-center hover:shadow-lg hover:shadow-blue-400/20 transition-all duration-300">
                <div className="w-12 h-12 flex items-center justify-center mx-auto mb-3">
                  <i className="ri-map-pin-line text-3xl text-blue-400"></i>
                </div>
                <div className="text-3xl font-bold text-white mb-2">2024</div>
                <div className="text-sm text-gray-400">دخول السوق البلجيكي</div>
              </div>

              <div className="bg-gradient-to-br from-dark-card to-dark-navy border border-neon-cyan/30 rounded-2xl p-6 text-center hover:shadow-lg hover:shadow-neon-cyan/20 transition-all duration-300">
                <div className="w-12 h-12 flex items-center justify-center mx-auto mb-3">
                  <i className="ri-team-line text-3xl text-neon-cyan"></i>
                </div>
                <div className="text-3xl font-bold text-white mb-2">4</div>
                <div className="text-sm text-gray-400">شراكات استراتيجية</div>
              </div>

              <div className="bg-gradient-to-br from-dark-card to-dark-navy border border-neon-cyan/30 rounded-2xl p-6 text-center hover:shadow-lg hover:shadow-neon-cyan/20 transition-all duration-300">
                <div className="w-12 h-12 flex items-center justify-center mx-auto mb-3">
                  <i className="ri-global-line text-3xl text-neon-cyan"></i>
                </div>
                <div className="text-3xl font-bold text-white mb-2">3</div>
                <div className="text-sm text-gray-400">أسواق دولية</div>
              </div>
            </div>
          </div>
        </section>

        {/* International Markets Progress */}
        <section className="py-16 px-6 bg-gradient-to-b from-transparent to-dark-navy/50">
          <div className="container mx-auto max-w-5xl">
            <div className="text-center mb-12">
              <h2 className="text-4xl font-bold text-white mb-4">الأسواق الدولية</h2>
              <p className="text-lg text-gray-300">
                حضور قوي في ثلاثة أسواق رئيسية مع نمو مستمر
              </p>
            </div>

            <div className="space-y-6">
              <div className="bg-gradient-to-br from-dark-card to-dark-navy border border-gray-700/50 rounded-2xl p-8 hover:border-neon-cyan/50 transition-all duration-300">
                <div className="flex items-center justify-between mb-4">
                  <div className="flex items-center gap-4">
                    <div className="w-12 h-12 flex items-center justify-center bg-red-500/10 rounded-xl">
                      <i className="ri-map-pin-line text-2xl text-red-400"></i>
                    </div>
                    <div>
                      <h3 className="text-2xl font-bold text-white">تركيا</h3>
                      <p className="text-sm text-gray-400">السوق الرئيسي منذ 2017</p>
                    </div>
                  </div>
                  <div className="text-3xl font-bold text-neon-green">45+</div>
                </div>
                <div className="w-full bg-dark-navy rounded-full h-3 overflow-hidden">
                  <div className="bg-gradient-to-r from-neon-green to-neon-cyan h-full rounded-full" style={{ width: '85%' }}></div>
                </div>
                <p className="text-sm text-gray-400 mt-2">صفقة ناجحة</p>
              </div>

              <div className="bg-gradient-to-br from-dark-card to-dark-navy border border-gray-700/50 rounded-2xl p-8 hover:border-neon-cyan/50 transition-all duration-300">
                <div className="flex items-center justify-between mb-4">
                  <div className="flex items-center gap-4">
                    <div className="w-12 h-12 flex items-center justify-center bg-yellow-500/10 rounded-xl">
                      <i className="ri-map-pin-line text-2xl text-yellow-400"></i>
                    </div>
                    <div>
                      <h3 className="text-2xl font-bold text-white">الصين</h3>
                      <p className="text-sm text-gray-400">شراكات مباشرة منذ 2019</p>
                    </div>
                  </div>
                  <div className="text-3xl font-bold text-neon-green">20+</div>
                </div>
                <div className="w-full bg-dark-navy rounded-full h-3 overflow-hidden">
                  <div className="bg-gradient-to-r from-neon-green to-neon-cyan h-full rounded-full" style={{ width: '60%' }}></div>
                </div>
                <p className="text-sm text-gray-400 mt-2">صفقة ناجحة</p>
              </div>

              <div className="bg-gradient-to-br from-dark-card to-dark-navy border border-gray-700/50 rounded-2xl p-8 hover:border-neon-cyan/50 transition-all duration-300">
                <div className="flex items-center justify-between mb-4">
                  <div className="flex items-center gap-4">
                    <div className="w-12 h-12 flex items-center justify-center bg-blue-500/10 rounded-xl">
                      <i className="ri-map-pin-line text-2xl text-blue-400"></i>
                    </div>
                    <div>
                      <h3 className="text-2xl font-bold text-white">بلجيكا</h3>
                      <p className="text-sm text-gray-400">دخول جديد في 2024</p>
                    </div>
                  </div>
                  <div className="text-3xl font-bold text-neon-green">6+</div>
                </div>
                <div className="w-full bg-dark-navy rounded-full h-3 overflow-hidden">
                  <div className="bg-gradient-to-r from-neon-green to-neon-cyan h-full rounded-full" style={{ width: '30%' }}></div>
                </div>
                <p className="text-sm text-gray-400 mt-2">صفقة ناجحة</p>
              </div>
            </div>
          </div>
        </section>

        {/* Growth Journey Timeline */}
        <section className="py-16 px-6">
          <div className="container mx-auto max-w-4xl">
            <div className="text-center mb-12">
              <h2 className="text-4xl font-bold text-white mb-4">رحلة النمو</h2>
              <p className="text-lg text-gray-300">
                مسيرة نجاح مستمرة من التأسيس حتى اليوم
              </p>
            </div>

            <div className="space-y-8">
              <div className="flex gap-6">
                <div className="flex flex-col items-center">
                  <div className="w-16 h-16 flex items-center justify-center bg-neon-cyan/20 rounded-full border-4 border-neon-cyan text-xl font-bold text-neon-cyan">
                    2017
                  </div>
                  <div className="w-1 flex-1 bg-gradient-to-b from-neon-cyan to-neon-green mt-4"></div>
                </div>
                <div className="flex-1 pb-8">
                  <div className="bg-gradient-to-br from-dark-card to-dark-navy border border-neon-cyan/30 rounded-2xl p-6">
                    <h3 className="text-2xl font-bold text-white mb-3">التأسيس والانطلاق</h3>
                    <p className="text-gray-400 leading-relaxed">
                      تأسيس طيبات الطبية العالمية وبدء العمل في السوق التركي مع أول شراكة استراتيجية
                    </p>
                  </div>
                </div>
              </div>

              <div className="flex gap-6">
                <div className="flex flex-col items-center">
                  <div className="w-16 h-16 flex items-center justify-center bg-neon-green/20 rounded-full border-4 border-neon-green text-xl font-bold text-neon-green">
                    2019
                  </div>
                  <div className="w-1 flex-1 bg-gradient-to-b from-neon-green to-neon-cyan mt-4"></div>
                </div>
                <div className="flex-1 pb-8">
                  <div className="bg-gradient-to-br from-dark-card to-dark-navy border border-neon-green/30 rounded-2xl p-6">
                    <h3 className="text-2xl font-bold text-white mb-3">التوسع الآسيوي</h3>
                    <p className="text-gray-400 leading-relaxed">
                      دخول السوق الصيني وإقامة شراكات مباشرة مع مصنعين رائدين في الأجهزة الطبية
                    </p>
                  </div>
                </div>
              </div>

              <div className="flex gap-6">
                <div className="flex flex-col items-center">
                  <div className="w-16 h-16 flex items-center justify-center bg-neon-cyan/20 rounded-full border-4 border-neon-cyan text-xl font-bold text-neon-cyan">
                    2023
                  </div>
                  <div className="w-1 flex-1 bg-gradient-to-b from-neon-cyan to-blue-400 mt-4"></div>
                </div>
                <div className="flex-1 pb-8">
                  <div className="bg-gradient-to-br from-dark-card to-dark-navy border border-neon-cyan/30 rounded-2xl p-6">
                    <h3 className="text-2xl font-bold text-white mb-3">النمو المتسارع</h3>
                    <p className="text-gray-400 leading-relaxed">
                      تحقيق أعلى معدل نمو سنوي مع زيادة عدد الصفقات وتنويع المنتجات
                    </p>
                  </div>
                </div>
              </div>

              <div className="flex gap-6">
                <div className="flex flex-col items-center">
                  <div className="w-16 h-16 flex items-center justify-center bg-blue-400/20 rounded-full border-4 border-blue-400 text-xl font-bold text-blue-400">
                    2024
                  </div>
                </div>
                <div className="flex-1">
                  <div className="bg-gradient-to-br from-dark-card to-dark-navy border border-blue-400/30 rounded-2xl p-6">
                    <h3 className="text-2xl font-bold text-white mb-3">دخول السوق الأوروبي</h3>
                    <p className="text-gray-400 leading-relaxed">
                      بدء العمل في السوق البلجيكي كبوابة للتوسع في أوروبا مع فرص واعدة
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Strategic Partners */}
        <section className="py-16 px-6 bg-gradient-to-b from-transparent to-dark-navy/50">
          <div className="container mx-auto">
            <div className="text-center mb-12">
              <h2 className="text-4xl font-bold text-white mb-4">الشركاء الاستراتيجيون</h2>
              <p className="text-lg text-gray-300 max-w-2xl mx-auto">
                شراكات قوية مع أبرز الشركات العالمية في مجال الأجهزة الطبية
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 max-w-6xl mx-auto">
              <div className="bg-gradient-to-br from-dark-card to-dark-navy border border-neon-cyan/30 rounded-2xl p-8 text-center hover:shadow-lg hover:shadow-neon-cyan/20 transition-all duration-300">
                <div className="w-20 h-20 flex items-center justify-center mx-auto mb-4 bg-gradient-to-br from-neon-cyan/20 to-transparent rounded-full">
                  <i className="ri-building-line text-5xl text-neon-cyan"></i>
                </div>
                <h3 className="text-2xl font-bold text-white mb-2">ResMed</h3>
                <p className="text-gray-400 text-sm mb-4">أجهزة التنفس الصناعي</p>
                <div className="flex items-center justify-center gap-2 text-sm text-neon-green">
                  <i className="ri-checkbox-circle-line"></i>
                  <span>شريك معتمد</span>
                </div>
              </div>

              <div className="bg-gradient-to-br from-dark-card to-dark-navy border border-neon-cyan/30 rounded-2xl p-8 text-center hover:shadow-lg hover:shadow-neon-cyan/20 transition-all duration-300">
                <div className="w-20 h-20 flex items-center justify-center mx-auto mb-4 bg-gradient-to-br from-neon-cyan/20 to-transparent rounded-full">
                  <i className="ri-building-line text-5xl text-neon-cyan"></i>
                </div>
                <h3 className="text-2xl font-bold text-white mb-2">BMC</h3>
                <p className="text-gray-400 text-sm mb-4">أجهزة طبية متقدمة</p>
                <div className="flex items-center justify-center gap-2 text-sm text-neon-green">
                  <i className="ri-checkbox-circle-line"></i>
                  <span>شريك معتمد</span>
                </div>
              </div>

              <div className="bg-gradient-to-br from-dark-card to-dark-navy border border-neon-cyan/30 rounded-2xl p-8 text-center hover:shadow-lg hover:shadow-neon-cyan/20 transition-all duration-300">
                <div className="w-20 h-20 flex items-center justify-center mx-auto mb-4 bg-gradient-to-br from-neon-cyan/20 to-transparent rounded-full">
                  <i className="ri-building-line text-5xl text-neon-cyan"></i>
                </div>
                <h3 className="text-2xl font-bold text-white mb-2">Yuwell</h3>
                <p className="text-gray-400 text-sm mb-4">مستلزمات طبية</p>
                <div className="flex items-center justify-center gap-2 text-sm text-neon-green">
                  <i className="ri-checkbox-circle-line"></i>
                  <span>شريك معتمد</span>
                </div>
              </div>

              <div className="bg-gradient-to-br from-dark-card to-dark-navy border border-neon-cyan/30 rounded-2xl p-8 text-center hover:shadow-lg hover:shadow-neon-cyan/20 transition-all duration-300">
                <div className="w-20 h-20 flex items-center justify-center mx-auto mb-4 bg-gradient-to-br from-neon-cyan/20 to-transparent rounded-full">
                  <i className="ri-building-line text-5xl text-neon-cyan"></i>
                </div>
                <h3 className="text-2xl font-bold text-white mb-2">Medel</h3>
                <p className="text-gray-400 text-sm mb-4">تقنيات طبية حديثة</p>
                <div className="flex items-center justify-center gap-2 text-sm text-neon-green">
                  <i className="ri-checkbox-circle-line"></i>
                  <span>شريك معتمد</span>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Transparency Section */}
        <section className="py-16 px-6">
          <div className="container mx-auto max-w-4xl">
            <div className="bg-gradient-to-br from-neon-cyan/10 to-neon-green/10 border-2 border-neon-cyan/30 rounded-2xl p-10 text-center">
              <div className="w-20 h-20 flex items-center justify-center mx-auto mb-6 bg-neon-cyan/20 rounded-full">
                <i className="ri-shield-check-line text-5xl text-neon-cyan"></i>
              </div>
              <h2 className="text-3xl font-bold text-white mb-4">الشفافية أساس نجاحنا</h2>
              <p className="text-lg text-gray-300 leading-relaxed max-w-2xl mx-auto">
                نؤمن بأن الشفافية الكاملة مع المستثمرين هي أساس بناء الثقة والنجاح المستدام. جميع البيانات والأرقام المعروضة موثقة ومتاحة للمراجعة من قبل المستثمرين الحاليين عبر لوحة التحكم الخاصة بهم.
              </p>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}
